export const passwordRegex = {
  REGEX_STRONG: new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$"),

  REGEX_MEDIUM1: new RegExp("^(?=.*?[A-Z])(?=.*?[a-z]).{8,}$"),

  REGEX_MEDIUM2: new RegExp("^(?=.*?[a-z])(?=.*?[0-9]).{8,}$"),
};
